import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SettingsService } from '../../../../../_services/settings.service';
import { Peca } from '../../_models/Peca';
import { CompanyPurchaseCondition } from '../../_models/CompanyPurchaseCondition';

@Component({
    selector: 'app-card', templateUrl: './card.component.html', styleUrls: ['./card.component.scss'],
    standalone: false
})
export class BuyerMercadoPartsfyListCardComponent
{
    @Input() public part: Peca;
    @Input() public companyPurchaseCondition: CompanyPurchaseCondition;
    public maxInstallments: number;
    @Output() openModalEvent = new EventEmitter<{modalId: number, part: Peca, maxInstallments?: number}>();

    public freeShippingMinValue: number;

    constructor(public settingService: SettingsService) { }

    ngOnInit() {
        this.freeShippingMinValue = null;

        let frete = this.companyPurchaseCondition?.shippings.find(frete => frete.holdingId == this.part.holdingId)

        this.freeShippingMinValue = frete?.shippingCost > 0 ? frete.minValue : 0

        const paymentTypes = this.companyPurchaseCondition.paymentTypes
                                .filter(pt => pt.holdingId === this.part.holdingId && pt.startValue <= this.part.price)
                                .map(pt => (pt.installmentsQuantity));

        this.maxInstallments = Math.max.apply(Math, paymentTypes.length == 0 ? [0] : paymentTypes);
    }

    public getCashbackValue() {
        let cashbackWithNoTax = (this.part.cashback / 100) * this.part.priceWithDiscount
        return  cashbackWithNoTax * 0.8
    }

    public openModal(modalId: number, part: Peca, maxInstallments: number): void {
        this.openModalEvent.emit({modalId, part, maxInstallments})
    }
}
